<ion-list class="ion-no-margin ion-no-padding">
  <ion-list-header color="primary" class="ion-padding-start">
    <ion-label class="filter">Filter By</ion-label>
    <ion-icon *ngIf="searchGrouping || searchLocation || searchCountry || searchType" class="clear" name="close" (click)="resetFilters()" title="Reset Filters"></ion-icon>
  </ion-list-header>
</ion-list>
<ion-list *ngIf="searchGrouping || searchLocation || searchCountry || searchType" class="ion-no-margin ion-no-padding" lines="none">
  <ion-list-header color="primary" (click)="currentFilters = !currentFilters">
    <ion-label>Current Filters</ion-label>
    <ion-icon *ngIf="currentFilters" name="remove" class="ion-margin-end"></ion-icon>
    <ion-icon *ngIf="!currentFilters" name="add" class="ion-margin-end"></ion-icon>
  </ion-list-header>
  <ng-container *ngIf="currentFilters">
    <ion-item *ngIf="searchGrouping" color="primary">
      <ion-checkbox (ionChange)="removeGroup()" value="{{searchGrouping}}" color="secondary" checked mode="ios"></ion-checkbox>
      <ion-label class="ion-padding-start">{{searchGrouping}}</ion-label>
    </ion-item>
    <ion-item *ngIf="searchClass" color="primary">
      <ion-checkbox (ionChange)="removeClass()" value="{{searchClass}}" color="secondary" checked mode="ios"></ion-checkbox>
      <ion-label class="ion-padding-start">{{searchClass}}</ion-label>
    </ion-item>
    <ion-item *ngIf="searchLocation" color="primary">
      <ion-checkbox (ionChange)="removeLocation()" value="{{searchLocation}}" color="secondary" checked mode="ios"></ion-checkbox>
      <ion-label class="ion-padding-start">{{searchLocation}}</ion-label>
    </ion-item>
    <ion-item *ngIf="searchCountry" color="primary">
      <ion-checkbox (ionChange)="removeCountry()" value="{{searchCountry}}" color="secondary" checked mode="ios"></ion-checkbox>
      <ion-label class="ion-padding-start">{{filters.name}}</ion-label>
    </ion-item>
    <ion-item *ngIf="searchRegion" color="primary">
      <ion-checkbox (ionChange)="removeRegion()" value="{{searchRegion}}" color="secondary" checked mode="ios"></ion-checkbox>
      <ion-label class="ion-padding-start">{{searchRegion}}</ion-label>
    </ion-item>
    <ion-item *ngIf="searchType" color="primary">
      <ion-checkbox (ionChange)="removeType()" value="{{searchType}}" color="secondary" checked mode="ios"></ion-checkbox>
      <ion-label class="ion-padding-start">{{searchType}}</ion-label>
    </ion-item>
    <ion-item *ngFor="let i of searchSalary" color="primary">
      <ion-checkbox (ionChange)="removeSalary(i)" value="{{i}}" color="secondary" checked mode="ios"></ion-checkbox>
      <ion-label class="ion-padding-start">{{i}}</ion-label>
    </ion-item>
    <ion-item *ngFor="let i of searchRate" color="primary">
      <ion-checkbox (ionChange)="removeRate(i)" value="{{i}}" color="secondary" checked mode="ios"></ion-checkbox>
      <ion-label class="ion-padding-start">{{i}}</ion-label>
    </ion-item>
  </ng-container>
</ion-list>
<ion-list class="ion-no-margin ion-no-padding" lines="none">
  <ion-list-header color="primary" (click)="byClassification = !byClassification">
    <ion-label>Category</ion-label>
    <ion-icon *ngIf="byClassification" name="remove" class="ion-margin-end"></ion-icon>
    <ion-icon *ngIf="!byClassification" name="add" class="ion-margin-end"></ion-icon>
  </ion-list-header>
  <ion-item *ngIf="byClassification" color="primary">
    <ion-label position="stacked">Industry</ion-label>
    <ion-select [(ngModel)]="searchGrouping" placeholder="Select industry" (ionChange)="filterGroup()" (searchOutput)="searchMethodChild()" interface="popover" [interfaceOptions]="{backdropDismiss: true, mode:'ios', showBackdrop: false, translucent: false}" #accessFilterGroup>
      <ion-select-option *ngFor="let grouping of groupings">{{grouping}}</ion-select-option>
    </ion-select>
  </ion-item>
  <ion-item *ngIf="searchGrouping && byClassification" color="primary">
    <ion-label position="stacked">Classification</ion-label>
    <ion-select [(ngModel)]="searchClass" (ionChange)="filterClass()" placeholder="Select classification" interface="popover" [interfaceOptions]="{backdropDismiss: true, mode:'ios', showBackdrop: false, translucent: false}">
      <ion-select-option *ngFor="let classification of classifications" [value]="classification">{{classification}}</ion-select-option>
    </ion-select>
  </ion-item>
</ion-list>
<ion-list class="ion-no-margin ion-no-padding" lines="none">
  <ion-list-header color="primary" (click)="byLocation = !byLocation">
    <ion-label>Location</ion-label>
    <ion-icon *ngIf="byLocation" name="remove" class="ion-margin-end"></ion-icon>
    <ion-icon *ngIf="!byLocation" name="add" class="ion-margin-end"></ion-icon>
  </ion-list-header>
  <ng-container *ngIf="byLocation">
    <ion-radio-group [(ngModel)]="searchLocation" (ionChange)="filterLocation()">
      <ion-item color="primary">
        <ion-radio color="white" mode="ios" value="remote"></ion-radio>
        <ion-label class="ion-padding-start">remote</ion-label>
      </ion-item>
      <ion-item color="primary">
        <ion-radio color="white" mode="ios" value="onsite"></ion-radio>
        <ion-label class="ion-padding-start">onsite</ion-label>
      </ion-item>
    </ion-radio-group>
    <ng-container *ngIf="searchLocation === 'onsite'">
      <ion-item color="primary">
        <ion-label position="stacked">Country</ion-label>
        <ion-select [(ngModel)]="searchCountry" placeholder="Select country" (ionChange)="filterCountry()" (searchOutput)="searchMethodChild()" interface="popover" [interfaceOptions]="{backdropDismiss: true, mode:'ios', showBackdrop: false, translucent: false}" #accessCountryGroup>
          <ng-container *ngFor="let country of countries">
            <ion-select-option *ngIf="country.active" [value]="country.code">{{country.name}}</ion-select-option>
          </ng-container>
        </ion-select>
      </ion-item>
      <ion-item *ngIf="searchCountry && regions" color="primary">
        <ion-label position="stacked">Region</ion-label>
        <ion-select [(ngModel)]="searchRegion" (ionChange)="filterRegion()" placeholder="Select region" interface="popover" [interfaceOptions]="{backdropDismiss: true, mode:'ios', showBackdrop: false, translucent: false}">
          <ion-select-option *ngFor="let region of regions" [value]="region">{{region}}</ion-select-option>
        </ion-select>
      </ion-item>
    </ng-container>    
  </ng-container>
</ion-list>
<ion-list *ngIf="service == 'future'" class="ion-no-margin ion-no-padding" lines="none">
  <ion-list-header color="primary" (click)="byType = !byType">
    <ion-label>Type</ion-label>
    <ion-icon *ngIf="byType" name="remove" class="ion-margin-end"></ion-icon>
    <ion-icon *ngIf="!byType" name="add" class="ion-margin-end"></ion-icon>
  </ion-list-header>
  <ng-container *ngIf="byType">
    <ion-item color="primary">
      <ion-label position="stacked">Job type</ion-label>
      <ion-select [(ngModel)]="searchType" placeholder="Select type" (ionChange)="filterType()" (searchOutput)="searchMethodChild()" interface="popover" [interfaceOptions]="{backdropDismiss: true, mode:'ios', showBackdrop: false, translucent: false}" #accessType>
        <ion-select-option *ngFor="let type of types" [value]="type">{{type}}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item *ngIf="searchType == 'Permanent'" color="primary">
      <ion-label position="stacked">Salary</ion-label>
      <ion-select [(ngModel)]="searchSalary" placeholder="Select salary" (ionChange)="filterType()" (searchOutput)="searchMethodChild()" interface="popover" [interfaceOptions]="{backdropDismiss: true, mode:'ios', showBackdrop: false, translucent: false}" multiple>
        <ion-select-option *ngFor="let salary of salaries" [value]="salary">{{salary}}k</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item *ngIf="searchType == 'Contract'" color="primary">
      <ion-label position="stacked">Hourly Rate</ion-label>
      <ion-select [(ngModel)]="searchRate" placeholder="Select hourly rate" (ionChange)="filterType()" (searchOutput)="searchMethodChild()" interface="popover" [interfaceOptions]="{backdropDismiss: true, mode:'ios', showBackdrop: false, translucent: false}" multiple>
        <ion-select-option *ngFor="let rate of rates" [value]="rate">{{rate}}ph</ion-select-option>
      </ion-select>
    </ion-item>
  </ng-container>
</ion-list>